

import { apiCall } from './apiCall';
  
  
  
export default function authenticateApi() {
  return {
    forgot: (data,token) => apiCall('/forgotPassword',data, token),
    reset: (data,token) => apiCall('/resetPassword',data, token),
    merchentRequest: (data,token) => apiCall('/merchentRegister',data, token),
    
  };
}








